import { BEST_DISTANCE_KEY, LAUNCH_X } from '../config/gameConstants';

export class DistanceManager {
  private bestDistance = 0;

  constructor() {
    this.bestDistance = this.readBestDistance();
  }

  getDistance(x: number): number {
    return Math.max(0, Math.floor((x - LAUNCH_X) / 10));
  }

  getBestDistance(): number {
    return this.bestDistance;
  }

  saveBestDistance(distance: number): number {
    if (distance > this.bestDistance) {
      this.bestDistance = distance;
      window.localStorage.setItem(BEST_DISTANCE_KEY, String(distance));
    }

    return this.bestDistance;
  }

  private readBestDistance(): number {
    const saved = Number(window.localStorage.getItem(BEST_DISTANCE_KEY));
    return Number.isFinite(saved) ? saved : 0;
  }
}
